import SnapActor from './SnapActor';

/**
 * 要素捕捉行为类,用于对指定要素类型进行捕捉
 * 对应的指定要素类型一般是通过传入指定要素的场景图层id实现.
 */
export default class FeatureSnapActor extends SnapActor {
    constructor(options) {
        super({
            filter: null, // 过滤函数
            ...options
        });

        /**
         * 捕捉到的要素对象
         * @type {object}
         */
        this.snapFeature = null;
    }

    clear() {
        super.clear();
        this.snapFeature = null;
    }

    /**
     * 捕捉方法
     * @param {object<geojson>} point 点经纬度几何，一般是鼠标的位置
     * @returns {object} snapResult - 捕捉结果
     */
    snap(point) {
        super.snap(point);

        const box = this.getBox(point);
        const features = this._featureSelector.selectByGeometry(box, this.options.filter);

        if (features.length === 0) {
            return null;
        }

        let minDis = Number.MAX_VALUE;
        const pointPixel = this._geojsonConverter.lngLatToPixel(point);
        for (let i = 0; i < features.length; ++i) {
            const feature = features[i];

            const pixelGeo = this._geojsonConverter.lngLatToPixel(feature.geometry);
            const res = this.nearestPoints(pointPixel, pixelGeo);
            if (res.distance < minDis) {
                minDis = res.distance;
                this.snapPoint = res.point2;
                this.snapFeature = feature;
            }
        }
        if (this.snapPoint) {
            this.snapPoint = this._geojsonConverter.pixelToLngLat(this.snapPoint);
        }

        return this.getSnapResult();
    }

    /**
     * 获得计算得到的最终捕捉数据结构.
     * @returns {object}
     */
    getSnapResult() {
        const result = super.getSnapResult();
        if (result) {
            result.feature = this.snapFeature;
        }

        return result;
    }
}
